import { ConfigPlugin, createRunOncePlugin } from "@expo/config-plugins";

const pkg = require("../package.json");

const withSoundAnalyzer: ConfigPlugin = (config) => {
  return config;
};

export default createRunOncePlugin(withSoundAnalyzer, pkg.name, pkg.version);
